import Grid from '@/global/components/ui/Grid'
import { Divider, MenuItem } from '@mui/material'
import { FormField, FormFieldSelect } from 'global/components/Form'
import IconeAjuda from 'global/components/IconeAjuda'
import { useFormContext } from 'react-hook-form'

export default function FormHoristaFaltas() {
    const { watch } = useFormContext()
    const faltaAutomatica = watch('faltaAutomatica')

    return (
        <Grid container>
            <Grid item xs={12}>
                <Divider>Configurações de horista</Divider>
            </Grid>
            <Grid item xs={12}>
                <span className="flex flex-col gap-1 select-none">
                    <span className="text-sm font-semibold inline-flex items-center">
                        Máximo de horas diárias
                        <IconeAjuda className="ml-2" size="small">
                            O trabalhador horista tem os mesmos limites legais
                            na jornada que os demais trabalhadores em regime
                            CLT: 8 horas diárias, porém, o empregador em comum
                            acordo com o empregado pode estabelecer condições de
                            trabalho diferentes.
                        </IconeAjuda>
                    </span>
                    <span className="text-xs">
                        Máximo de horas que o funcionário pode trabalhar por dia
                        antes de ser considerado hora extra. Se aplica quando o
                        funcionário não possui tabela de horário.
                    </span>
                    <span className="text-xs">
                        Deixe em branco para indeterminado
                    </span>
                </span>
            </Grid>
            {...[
                {
                    short: 'seg',
                    long: 'Segunda-feira',
                },
                {
                    short: 'ter',
                    long: 'Terça-feira',
                },
                {
                    short: 'qua',
                    long: 'Quarta-feira',
                },
                {
                    short: 'qui',
                    long: 'Quinta-feira',
                },
                {
                    short: 'sex',
                    long: 'Sexta-feira',
                },
                {
                    short: 'sab',
                    long: 'Sábado',
                },
                {
                    short: 'dom',
                    long: 'Domingo',
                },
                { short: 'fer', long: 'Feriado' },
            ].map(dia => (
                <Grid item sm={3} xs={6} key={dia.short}>
                    <FormField
                        name={`horasExtras.${dia.short}.maximoHorasDiarias`}
                        label={dia.long}
                        type="time"
                    />
                </Grid>
            ))}
            <Grid item xs={12}>
                <Divider>Faltas justificadas/injustificadas</Divider>
            </Grid>
            <Grid item xs={6} sm={4}>
                <FormFieldSelect
                    name="faltaAutomatica"
                    label="Falta padrão"
                    options={[
                        {
                            label: 'Injustificada',
                            value: 'injustificada',
                        },
                        { label: 'Justificada', value: 'justificada' },
                    ]}
                    endAdornment={
                        <IconeAjuda className="mr-4">
                            Caso utilize controle de faltas
                            justificadas/injustificadas, selecione o tipo de
                            falta que será cadastrada automaticamente para os
                            dias em que houver faltas para os funcionários.
                            <br />
                            <br />
                            Caso selecione "Nenhuma", você ainda poderá
                            cadastrar faltas manualmente para cada funcionário.
                        </IconeAjuda>
                    }
                >
                    <MenuItem value={null as any}>
                        <em>Nenhuma</em>
                    </MenuItem>
                </FormFieldSelect>
            </Grid>
            <Grid item xs={6} sm={4}>
                <FormField
                    type="time"
                    name="horasFaltaAutomatica"
                    label="Limite"
                    disabled={!faltaAutomatica}
                    InputProps={{
                        endAdornment: (
                            <div className="inline-flex items-baseline">
                                <span>h</span>
                                <IconeAjuda>
                                    Quando definido, o sistema irá considerar a
                                    falta definida no campo{' '}
                                    <strong>Falta padrão</strong> apenas quando
                                    faltas superarem o valor configurado neste
                                    campo.
                                </IconeAjuda>
                            </div>
                        ),
                    }}
                    helperText="Deixe em branco para considerar o dia inteiro"
                />
            </Grid>
            <Grid item xs={6} sm={4}>
                <FormFieldSelect
                    name="horasExcedentesConsideraDiaInteiro"
                    label="Horas excedentes considera dia inteiro"
                    options={[
                        { label: 'Sim', value: 'true' },
                        { label: 'Não', value: 'false' },
                    ]}
                    endAdornment={
                        <IconeAjuda className="mr-4 mt-4">
                            Caso habilitado, quando as horas de falta do
                            funcionário ultrapassarem o limite definido no campo{' '}
                            <strong>Limite</strong>, o sistema irá considerar o
                            dia inteiro como falta do tipo definido no campo{' '}
                            <strong>Falta padrão</strong>.
                            <br />
                            <br />
                            Caso desabilitado, o sistema irá considerar apenas
                            as horas excedentes como falta do tipo definido no
                            campo <strong>Falta padrão</strong>.
                        </IconeAjuda>
                    }
                />
            </Grid>
        </Grid>
    )
}
